import { TransactionStatus } from "../../contract/pam.js";
import { timestampSecondsToMoment, sortByTimestamp } from "../../utils/date.js";
import "react-intl";
function getTransactionDuration({ history, started_at }) {
  function sortHistory(first, second) {
    return sortByTimestamp(first.logged_at, second.logged_at);
  }
  const sortedTransactionHistory = history ? [...history].sort(sortHistory) : [];
  const startedDate = timestampSecondsToMoment(started_at?.seconds);
  const endDateTimestamp = sortedTransactionHistory.find(
    (i) => i.status === TransactionStatus.InProgress || i.status === TransactionStatus.Failed || i.status === TransactionStatus.Rejected
  )?.logged_at;
  const endDate = timestampSecondsToMoment(endDateTimestamp?.seconds);
  const formattedValue = endDate ? startedDate?.from(endDate, true) : startedDate?.fromNow(true);
  return formattedValue;
}
function getTransactionStatusColor(status) {
  const mapping = {
    [TransactionStatus.InProgress]: "lightBlue",
    [TransactionStatus.Failed]: "yellow",
    [TransactionStatus.Rejected]: "yellow",
    [TransactionStatus.Cancelled]: "yellow",
    [TransactionStatus.OnHoldPayment]: "orange",
    [TransactionStatus.OnHoldRisk]: "orange",
    [TransactionStatus.Pending]: "grey",
    [TransactionStatus.RiskAuthorized]: "grey",
    [TransactionStatus.Succeeded]: "green",
    [TransactionStatus.Deleted]: "red"
  };
  return mapping[status];
}
export {
  getTransactionDuration,
  getTransactionStatusColor
};
//# sourceMappingURL=utils.js.map
